import React, { Component, Fragment } from 'react'

import CssBaseline from '@material-ui/core/CssBaseline'
import { MuiThemeProvider } from '@material-ui/core/styles'

import { Provider } from 'react-redux'
import { Route, Switch, Redirect } from 'react-router' // react-router v4
import { ConnectedRouter } from 'connected-react-router'

import I18n from 'redux-i18n'
import { translations } from './traslations/translations'

import baseLayout from './components/shared/layouts/Base'
import Accommodations from './components/pages/Accommodations'
import TouristSource from './components/pages/TouristSource'
import GuestsSatisfaction from './components/pages/GuestsSatisfaction'
import Deepening from './components/pages/Deepening'

import store from './stores'
import history from './stores/history'
import IddMuiTheme from './IddMuiTheme'

import './App.css';

class App extends Component {
  render() {

    return (

      <Fragment>
        <CssBaseline />
      
        <MuiThemeProvider theme={IddMuiTheme}>
        
          <Provider store={store}>

            <I18n translations={translations} initialLang="it">

              <ConnectedRouter history={history}>
                <div>
                  <Switch>
                    <Route path="/accommodations" component={baseLayout(Accommodations)} />
                    <Route path="/tourist_source" component={baseLayout(TouristSource)} />
                    <Route path="/guests_satisfaction" component={baseLayout(GuestsSatisfaction)} />
                    <Route path="/deepening" component= {baseLayout(Deepening)} />
                    <Redirect to="/tourist_source" />
                  </Switch>
                </div>
              </ConnectedRouter>

            </I18n>

          </Provider>

        </MuiThemeProvider>

      </Fragment>
    );
  }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js